export default from './PublicLayout';



// WEBPACK FOOTER //
// ./src/layouts/public-layout/index.js